import {
  ArticleListIcon,
  BusinessTagIcon,
  Challenge_community,
  CourseListIcon,
  DraftStatusIcon,
  EventsListIcon,
  FormBuilderListIcon,
  General_community,
  News_community,
  PagesListIcon,
  PendingStatusIcon,
  PollListIcon,
  PublishedStatusIcon,
  QuizListIcon,
  SchedulePublishStatusIcon,
  ScheduleUnpublishStatusIcon,
  SpaceListIcon,
  SpacePrivateIcon,
  SpacePublicIcon,
  SystemTagIcon,
  UnpublishedStatusIcon,
  VODListIcon,
} from "@platformx/shared/static-assets";

export const statusIcons: any = {
  draft: DraftStatusIcon,
  published: PublishedStatusIcon,
  unpublished: UnpublishedStatusIcon,
  schedulePublish: SchedulePublishStatusIcon,
  scheduleUnpublish: ScheduleUnpublishStatusIcon,
  pending: PendingStatusIcon,
  public: SpacePublicIcon,
  private: SpacePrivateIcon,
};
export const stateIcons: any = {
  draft: DraftStatusIcon,
  published: PublishedStatusIcon,
  unpublished: UnpublishedStatusIcon,
  schedulePublish: SchedulePublishStatusIcon,
  scheduleUnpublish: ScheduleUnpublishStatusIcon,
  pending: PendingStatusIcon,
};
export const iconsList: any = {
  sitepage: PagesListIcon,
  article: ArticleListIcon,
  quiz: QuizListIcon,
  vod: VODListIcon,
  poll: PollListIcon,
  event: EventsListIcon,
  courses: CourseListIcon,
  news: News_community,
  general: General_community,
  "challenges-announcement": Challenge_community,
  Space: SpaceListIcon,
  SiteTags: BusinessTagIcon,
  SystemTags: SystemTagIcon,
  formbuilder: FormBuilderListIcon,
};

export const SITE_TAGS = "SiteTags";
export const SYSTEM_TAGS = "SystemTags";
